import { render, staticRenderFns } from "./SearchListTemplate.vue?vue&type=template&id=f23b292a&scoped=true&"
import script from "./SearchListTemplate.vue?vue&type=script&lang=js&"
export * from "./SearchListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23b292a",
  null
  
)

export default component.exports